module.exports = __webpack_public_path__ + "static/011_Mural-aa22506ad6d2986e8daef5447fccfd64.jpg";